import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener(
      "turbo:submit-start",
      this.showLoader.bind(this)
    )
    this.element.addEventListener("submit", this.showLoader.bind(this)) // fallback
  }

  showLoader(event) {
    // Select all submit buttons in the form
    const buttons = this.element.querySelectorAll(
      "input[type=submit], button[type=submit]"
    )

    buttons.forEach((btn) => {
      // 👇 Skip loader if this button has data-prevent-loader
      if (btn.dataset.preventLoader === "true") return

      if (!btn || btn.classList.contains("loading") || btn.disabled) return

      btn.classList.add("loading")
      btn.disabled = true

      if (btn.tagName === "BUTTON") {
        const text = btn.innerText
        btn.dataset.originalText = text
        btn.innerHTML = `
          <i class="fi fi-bs-refresh spin d-inline-flex" style="display:inline-block; animation: spin 1s linear infinite; transform-origin: center center;"></i>
          <span>${text}</span>
        `
        btn.disabled = true
      } else if (btn.tagName === "INPUT") {
        const text = btn.value
        btn.dataset.originalText = text
        btn.value = "Loading..." // fallback for inputs
        btn.disabled = true
      }
    })
  }
}
